import { cn } from 'ethcss'
import styles from './scrollbarX.jcss'
import React, { useEffect, useRef, useState } from 'react'

export const ScrollbarX = (p_: any) => {
    const draggableHandle = useRef<any>(null)
    const containerRef = useRef<any>(null)
    const [startPosition, setStart] = useState<number>(0)
    const [hideScrollbar, setHideScrollbar] = useState<boolean>(false)

    const onScroll = (e: any) => {
        setStart(e.target.scrollLeft / p_.scrollFactor)
    }

    useEffect(() => {
        if (
            containerRef &&
            containerRef.current &&
            draggableHandle &&
            draggableHandle.current &&
            containerRef.current.offsetWidth <= draggableHandle.current.offsetWidth
        ) {
            setHideScrollbar(true)

            return
        }

        setHideScrollbar(false)
    }, [containerRef.current, p_.scrollHandleWidth])

    useEffect(() => {
        if (!p_.listRef) return

        p_.listRef.onscroll = onScroll

        return () => {
            if (p_.listRef) {
                p_.listRef.onscroll = null
            }
        }
    }, [p_.listRef])

    useEffect(() => {
        if (draggableHandle && draggableHandle.current && containerRef && containerRef.current) {
            draggableHandle.current.onmousedown = function (e: any) {
                e.preventDefault()
                e.stopImmediatePropagation()

                let mouseX = 0
                let mouseY = 0

                document.body.onmouseleave = (e: any) => {
                    mouseX = e.pageX
                    mouseY = e.pageY
                    if (mouseY >= 0 && mouseY <= window.innerHeight && mouseX >= 0 && mouseX <= window.innerWidth)
                        return

                    document.body.onmousemove = null
                    document.body.onmouseout = null
                }

                const startPoint = e.pageX
                const maxValue = containerRef.current.offsetWidth - draggableHandle.current.offsetWidth
                let difference = 0
                let stepValue = startPosition

                if (p_.listRef) {
                    p_.listRef.onscroll = null
                }

                document.body.onmousemove = function (e) {
                    e.stopPropagation()
                    e.stopImmediatePropagation()

                    difference = e.pageX - startPoint

                    if (difference >= 0) {
                        stepValue = startPosition + difference
                    } else {
                        stepValue = startPosition - Math.abs(difference)
                    }
                    if (stepValue < 0) {
                        stepValue = 0
                    }
                    if (stepValue > maxValue) {
                        stepValue = maxValue
                    }

                    draggableHandle.current.style.left = stepValue + 'px'

                    p_.listRef.scroll({
                        top: 0,
                        left: stepValue * p_.scrollFactor,
                    })
                }
                document.body.onmouseup = function () {
                    document.body.onmousemove = document.body.onmouseup = null
                    setStart(stepValue)
                    if (p_.listRef) {
                        p_.listRef.onscroll = onScroll
                    }
                }
            }
        }

        return () => {
            if (draggableHandle && draggableHandle.current) {
                draggableHandle.current.onmousedown = null
                document.body.onmousemove = null
                document.body.onmouseup = null
            }
        }
    }, [draggableHandle.current, containerRef.current, startPosition, p_.listRef])

    return (
        <div
            className={cn(styles.leftIndent, styles.scrollbarX, styles.col2)}
            style={{ opacity: hideScrollbar ? 0 : 1 }}
        >
            <div ref={containerRef} className={styles.scrollbarInner}>
                <div
                    ref={draggableHandle}
                    className={styles.scrollbarHandle}
                    style={{ width: p_.scrollHandleWidth, left: startPosition }}
                />
            </div>
        </div>
    )
}
